import type { GNavItem } from "~/types/navigation";
import { GrapeAppAuthorization } from "@grape-law-firm/grape-common-notion-client";

export function useNavigation() {
  const navItems: GNavItem[] = [
    {
      label: "Home",
      icon: "i-heroicons-home",
      to: "/home",
    },
    // {
    //   label: "Timesheets",
    //   icon: "i-heroicons-clock",
    //   to: "/timesheets",
    //   wiki: grapeWiki.timesheets,
    // },
    // {
    //   label: "Translator",
    //   icon: "i-heroicons-language",
    //   to: "/translator",
    //   wiki: grapeWiki.translator,
    // },
    {
      label: "Missive Helper",
      icon: "i-heroicons-envelope",
      to: "/missive",
      requiredAuthorizations: currentAuthorizations =>
        currentAuthorizations.includes(GrapeAppAuthorization.MissiveHelper),
      wiki: grapeWiki.missive,
    },
    // {
    //   label: "Balance Follow-Up",
    //   icon: "i-heroicons-banknotes",
    //   to: "/balanceFollowUp",
    //   requiredAuthorizations: currentAuthorizations =>
    //     currentAuthorizations.includes(GrapeAppAuthorization.BalanceFollowUp),
    //   wiki: grapeWiki.balanceFollowUp,
    // },
    // {
    //   label: "Case Filing",
    //   icon: "i-heroicons-archive-box",
    //   to: "/caseFiling",
    //   requiredAuthorizations: currentAuthorizations =>
    //     currentAuthorizations.includes(GrapeAppAuthorization.CaseFilingOwn) || currentAuthorizations.includes(GrapeAppAuthorization.CaseFilingTeam),
    //   wiki: grapeWiki.search,
    // },
    // {
    //   label: "Visa Bulletin",
    //   icon: "i-heroicons-document-plus",
    //   to: "/bulletin",
    //   requiredAuthorizations: currentAuthorizations =>
    //     currentAuthorizations.includes(GrapeAppAuthorization.VisaBulletin),
    //   wiki: grapeWiki.bulletin,
    // },
    // {
    //   label: "Client Ticket",
    //   icon: "i-heroicons-user",
    //   to: "/ticket",
    //   requiredAuthorizations: currentAuthorizations =>
    //     currentAuthorizations.includes(GrapeAppAuthorization.ClientTicket),
    //   wiki: grapeWiki.ticket,
    // },
    // {
    //   label: "Search",
    //   icon: "i-heroicons-magnifying-glass",
    //   to: "/search",
    //   requiredAuthorizations: currentAuthorizations =>
    //     currentAuthorizations.includes(GrapeAppAuthorization.Search),
    //   wiki: grapeWiki.search,
    // },
    // {
    //   label: "GrapeBot",
    //   icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"scale-125\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M5.616 20q-.672 0-1.144-.472T4 18.385V9q0-2.077 1.462-3.538T9 4h6q2.077 0 3.539 1.462T20 9v9.385q0 .67-.472 1.143q-.472.472-1.143.472zm0-1h12.769q.269 0 .442-.173t.173-.442V9q0-1.65-1.175-2.825T15 5H9Q7.35 5 6.175 6.175T5 9v9.385q0 .269.173.442t.443.173M9 11.5q-.633 0-1.066-.434Q7.5 10.633 7.5 10t.434-1.066T9 8.5t1.066.434q.434.433.434 1.066t-.434 1.066T9 11.5m6 0q-.633 0-1.066-.434Q13.5 10.633 13.5 10t.434-1.066T15 8.5t1.066.434q.434.433.434 1.066t-.434 1.066T15 11.5M7.5 19v-1.884q0-.672.472-1.144t1.144-.472h5.769q.67 0 1.143.472q.472.472.472 1.144V19h-1v-1.884q0-.27-.173-.443t-.442-.173H12.5V19h-1v-2.5H9.116q-.27 0-.443.173t-.173.443V19zm-1.884 0H19H5z\"/></svg>",
    //   to: "/grapeBot",
    //   wiki: grapeWiki.grapeBot,
    // },
  ];
  const missiveNavItems = [...navItems];

  const currentNavItem = computed(() => {
    const route = useRoute();
    return navItems.find(navItem => navItem.to === route.path);
  });

  const currentWikiContent = computed(() => {
    return currentNavItem.value?.wiki;
  });

  return { navItems, missiveNavItems, currentNavItem, currentWikiContent };
}
